module.exports = __webpack_public_path__ + "static/media/robotoi5.db4a2a23.woff2";